import { BooleanValue } from 'vega';
import { TopLevelSpec as VegaLiteSpec } from 'vega-lite';
import { MarkDef } from 'vega-lite/build/src/mark';
import { Scale } from 'vega-lite/build/src/scale';
import { LayerSpec, UnitSpec } from 'vega-lite/build/src/spec';
import { TimeUnit } from 'vega-lite/build/src/timeunit';
import { liteBaseConfig } from '../vegaShared';

export interface IBarOptions {
  data: any[];
  timeUnit: TimeUnit;
  xField: string;
  color?: string;
  colorScale?: Scale;
  colorField: string;
  yField: string;
  xAxisTitle?: string;
  yAxisTitle?: string;
  xLabels?: boolean;
  yLabels?: boolean;
  yFormat?: string;
  barLabels?: boolean;
  barLabelConfig?: MarkDef<'text'>;
  width?: number | 'container';
  height?: number | 'container';
}

export const genBarSpec = (options: IBarOptions): VegaLiteSpec => {
  const xAxis = { labelAngle: 0, title: options.xAxisTitle || null, labels: !!options.xLabels, domain: !!options.xLabels, ticks: !!options.xLabels };
  const yAxis = {
    title: options.yAxisTitle || null,
    labels: !!options.yLabels,
    domain: !!options.yLabels,
    ticks: !!options.yLabels,
    format: options.yFormat || '0.2s',
  };
  const barLayer: UnitSpec = {
    mark: {
      type: 'bar',
      tooltip: true,
      cornerRadiusTopLeft: 6,
      cornerRadiusTopRight: 6,
      align: 'left',
      ...(options.color && { fill: options.color }),
    },
  };
  const textLayer: UnitSpec = {
    mark: {
      type: 'text',
      align: 'center',
      baseline: 'bottom',
      dy: -3,
      fontWeight: 700,
      fontSize: 11,
      ...options.barLabelConfig,
    },
    encoding: {
      text: {
        field: options.yField,
        type: 'quantitative',
        format: options.yFormat || '0.2s',
        condition: {
          test: 'width < 800',
          value: '',
        },
      },
    },
  };

  const layers: UnitSpec[] = [barLayer];
  if (options.barLabels) {
    layers.push(textLayer);
  }

  const config = {
    ...liteBaseConfig(),
  };
  const baseSpec: VegaLiteSpec = {
    $schema: 'https://vega.github.io/schema/vega-lite/v4.json',
    autosize: 'fit',
    width: options.width || 'container',
    height: options.height || 100,
    // @ts-ignore
    config,
    ...(options.colorScale?.domain && {
      transform: [
        {
          // @ts-ignore
          calculate: `indexof(['${options.colorScale.domain.join("', '")}'], datum.${options.colorField})`,
          as: 'order',
        },
      ],
    }),
    encoding: {
      x: { field: options.xField, timeUnit: { unit: options.timeUnit }, type: 'temporal', axis: xAxis, band: 0.7 },
      y: { field: options.yField, axis: yAxis, type: 'quantitative' },
      ...(options.colorField && { color: { field: options.colorField, legend: null, scale: options.colorScale || {} } }),
      ...(options.colorScale?.domain && { order: { field: 'order', type: 'ordinal' } }),
    },
    layer: layers,
    data: { values: options.data },
  };
  return baseSpec;
};
